import { type ReactNode } from "react";
import { SidebarTrigger } from "@/components/ui/sidebar";
import { ThemeToggle } from "@/components/theme-toggle";
import { ErrorBoundary } from "@/components/error-boundary";
import { SuspenseBoundary } from "@/components/suspense-boundary";

interface AppLayoutProps {
  children: ReactNode;
  showHeader?: boolean;
}

export function AppLayout({ children, showHeader = true }: AppLayoutProps) {
  return (
    <div className="flex flex-col flex-1 overflow-hidden">
      {showHeader && (
        <header className="flex h-12 items-center justify-between border-b px-4 bg-background dark:bg-card shrink-0">
          <SidebarTrigger data-testid="button-sidebar-toggle" />
          <ThemeToggle />
        </header>
      )}
      <main className="flex-1 overflow-hidden flex flex-col">
        <ErrorBoundary>
          <SuspenseBoundary>
            {children}
          </SuspenseBoundary>
        </ErrorBoundary>
      </main>
    </div>
  );
}
